import React, { useEffect, useState } from "react";
import useHttp from "../../Hooks/use-http";
import { FileUpload as FileUploadIcon } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Grid,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";

const DriverRegistrationDriverDocument = ({
  setSnackbarOpen,
  setSnackbarMessage,
  isUploading,
  setIsUploading,
  step,
  emailID,
  documents,
  setDocuments,
  vehicleCustom,
}) => {
  const [isUpload, setIsUpload] = useState(false);

  const { sendRequest, isLoading } = useHttp();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await sendRequest({
          url: "/documentsmaster",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
          },
        });

        if (data?.status === 200 || data?.status === 201) {
          const filteredDocuments =
            data?.documentMaster.filter(
              (doc) =>
                doc.category === "Driver" ||
                (vehicleCustom && doc.category === "Vehicle")
            ) || [];
          const newDocuments = filteredDocuments.map((doc) => ({
            name: doc.documentName || "",
            type: doc.type,
            documentID: doc.documentID,
            number: "",
            category: doc.category,
            expiryDate: "",
            file: null,
            url: "",
            error: "",
            preview: "",
            isUploaded: false, // New property for upload status
            required: doc.required,
            hasExpiry: doc.hasExpiry,
          }));
          setDocuments(newDocuments);
        }
      } catch (error) {
        console.error("Error fetching document master", error);
      }
    };

    fetchData(); // Call the async function
  }, [sendRequest]);

  const documentChangeHandler = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = file.type.startsWith("image/")
        ? URL.createObjectURL(file) // Show image preview
        : file.name; // Show filename if not an image
      setDocuments((prev) => {
        const updatedDocuments = [...prev];
        updatedDocuments[index] = {
          ...updatedDocuments[index],
          file: file,
          preview: preview,
          error: "",
        };
        return updatedDocuments;
      });
    }
  };

  const uploadFileToBackend = async (index) => {
    setIsUploading(true);

    const file = documents[index].file;
    const FolderName = "driver";
    const uniqueID = emailID;
    const documentID = documents[index].documentID;

    try {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileName", file?.name ?? "random");
      formData.append("folderName", FolderName);
      formData.append("uniqueID", uniqueID);
      formData.append("documentID", documentID);
      formData.append("fileExtension", fileExtension);

      // const response = await fetch("http://localhost:4001/documentfileupload", {
      const response = await fetch(
        "https://littleinfinity.in:4001/documentfileupload",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      if (response.ok) {
        const fileUrl = data?.data;
        setDocuments((prev) => {
          const updatedDocuments = [...prev];
          updatedDocuments[index] = {
            ...updatedDocuments[index],
            url: fileUrl,
            isUploaded: true, // Mark as uploaded
          };
          return updatedDocuments;
        });
        setSnackbarMessage("File uploaded successfully!");
      } else {
        console.error("Error in upload:", data.message);
        setSnackbarMessage("Error uploading file: " + data.message);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setSnackbarMessage("Error uploading file!");
    } finally {
      setIsUploading(false);
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Grid container spacing={2} sx={{ marginTop: 2 }}>
        {documents.map((doc, index) => {
          return (
            <Grid item xs={12} key={index}>
              <Box
                sx={{
                  padding: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  backgroundColor: "#fafafa",
                  boxShadow: 2,
                  transition: "all 0.3s ease",
                  "&:hover": { boxShadow: 4 },
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        color: "black",
                        fontWeight: "500",
                        fontSize: "18px",
                      }}
                    >
                      <strong>
                        {doc.name}
                        {doc.required && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </strong>
                    </Typography>
                  </Grid>

                  {/* Inputs for updates */}
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      label="Document Number"
                      value={doc.number || ""}
                      onChange={(e) => {
                        const updatedDocuments = [...documents];
                        updatedDocuments[index].number = e.target.value;
                        setDocuments(updatedDocuments);
                      }}
                      variant="standard"
                      size="small"
                      sx={{
                        backgroundColor: "#fafafa",
                        "&:hover": { backgroundColor: "#f1f1f1" },
                      }}
                    />
                  </Grid>
                  <Grid item xs={4}>
                    {doc.hasExpiry && (
                      <TextField
                        fullWidth
                        label="Expiry Date"
                        type="date"
                        value={doc.expiryDate || ""}
                        onChange={(e) => {
                          const updatedDocuments = [...documents];
                          updatedDocuments[index].expiryDate = e.target.value;
                          setDocuments(updatedDocuments);
                        }}
                        variant="standard"
                        size="small"
                        sx={{
                          backgroundColor: "#fafafa",
                          "&:hover": { backgroundColor: "#f1f1f1" },
                        }}
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  </Grid>

                  <Grid item xs={4}>
                    {!doc.isUploaded ? (
                      <>
                        <Button
                          variant="contained"
                          component="label"
                          size="small"
                          // disabled={!doc.expiryDate || !doc.number}
                          sx={{
                            width: "80%",
                            padding: "8px 0",
                            marginLeft: "5%",
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            boxShadow: 2,
                            transition: "all 0.3s ease",
                            "&:hover": { backgroundColor: "#1565c0" },
                          }}
                          startIcon={<FileUploadIcon />}
                        >
                          {doc.preview ? "File Selected" : "Select File"}
                          <input
                            type="file"
                            hidden
                            onChange={(e) => documentChangeHandler(index, e)}
                          />
                        </Button>

                        {/* Preview the file */}
                        {doc.preview && (
                          <Box
                            sx={{
                              marginTop: 1,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              backgroundColor: "#f4f4f4",
                              padding: "10px",
                              borderRadius: 1,
                              boxShadow: 1,
                              transition: "all 0.3s ease",
                            }}
                          >
                            {doc.preview ? (
                              <img
                                src={doc.preview}
                                alt="Preview"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: 5,
                                }}
                              />
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{ color: "#007bff" }}
                              >
                                {doc.preview}
                              </Typography>
                            )}
                            <Button
                              variant="contained"
                              onClick={() => uploadFileToBackend(index)}
                              sx={{
                                width: "70%",
                                marginTop: 1,
                                padding: "8px 0",
                                backgroundColor: "#44B150",
                                color: "#fff",
                                boxShadow: 2,
                              }}
                              disabled={isUploading}
                            >
                              {isUploading ? (
                                <CircularProgress size={24} />
                              ) : (
                                "Upload File"
                              )}
                            </Button>
                          </Box>
                        )}
                      </>
                    ) : (
                      <Typography
                        sx={{
                          color: "green",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Successfully Uploaded
                      </Typography>
                    )}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default DriverRegistrationDriverDocument;
